<template lang="pug">
.branch-video
  .branch-back(:style="`height: ${backHeight}px;`", @click="onClose")
  dl.branch-info(:style="`top: ${backHeight}px;`")
    dt {{branchVideo.name}}
    dd 支线任务：请观看视频
  .branch-video-box
    video(:src="branchVideo.url", ref="branchVideo", controls)
  .branch-tip
    .branch-tip-close(@click="onClose")
    span(v-show="isFinish") 视频观看完毕！贴纸+1！
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'Tip',
  props: {
    backHeight: Number,
    branchVideo: Object,
  },
  data() {
    return {
      isFinish: false,
    }
  },
  computed: {
    ...mapState('app', ['sysInfo', 'router', 'user']),
  },
  methods: {
    ...mapActions('app', ['GetFootprintAddTaskBranchFinish', 'GetFootprintTaskListToday']),
    onClose() {
      this.$emit('close');
    },
    fetchFootprintAddTaskBranchFinish() {
      if (this.isFinish) {
        return;
      }
      this.GetFootprintAddTaskBranchFinish({
        userId: this.user.id,
        taskBranchId: this.branchVideo.code,
      })
        .then(() => {
          // 需要同步支线数据？
          this.GetFootprintTaskListToday({ userId: this.user.id });
        })
        .catch((err) => {
          console.log(err)
        })
    },
  },
  mounted() {
    this.$refs.branchVideo.play();
    this.$refs.branchVideo.onended = () => {
      this.fetchFootprintAddTaskBranchFinish();
      this.isFinish = true;
    };
    this.$refs.branchVideo.ontimeupdate = e => {
      if (this.$refs.branchVideo && this.$refs.branchVideo.currentTime > 30) {
        this.fetchFootprintAddTaskBranchFinish();
        this.isFinish = true;
      }
    }
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common"
@import "src/styles/footprint"
.branch-video
  +full; z-index: 9999; position: fixed
  background: rgba(0, 0, 0, 0.75); color: #FFFFFF
  +flex-center
.branch-back
  box-sizing: content-box; padding: 0 pxRes(16.54); width: pxRes(21)
  position: absolute; top: 0; left: 0
  background: url("~assets/footprint/icon-back-w.png") center no-repeat
  background-size: pxRes(25)
dl.branch-info
  position: absolute; left: pxRes(30); top: pxRes(30); margin: 0
  dt
    +text(32, 42)
  dd
    +text(16, 22); margin: 0
.branch-video-box
  padding-top: pxRes(150)
  video
    max-width: 100%
.branch-tip
  padding: pxRes(124) 0 0; text-align: center; 
  +text(16, 22); margin: 0; color: #FFFFFF; height: pxRes(88)
  position: relative;
  &-close
    height: pxRes(37); width: pxRes(37)
    position: absolute; top: pxRes(40); left: 50%; margin-left: pxRes(-37/2)
    background: url("~assets/footprint/icon-video-close.png") center no-repeat
    background-size: pxRes(37)
</style>
